/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsReplyTimes } from './WebApiModelsReplyTimes';
import {
    WebApiModelsReplyTimesFromJSON,
    WebApiModelsReplyTimesFromJSONTyped,
    WebApiModelsReplyTimesToJSON,
} from './WebApiModelsReplyTimes';
import type { WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto } from './WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto';
import {
    WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto';

/**
 * What a logged in member needs to answer an event: who the member is and the reply the member already has.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto {
    /**
     * Name from the member register.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    name?: string | null;
    /**
     * E-mail from the member register.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    email?: string | null;
    /**
     * The reply the member already has for the event, or 0.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    replyId?: number;
    /**
     * The message of the reply.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    message?: string | null;
    /**
     * The answers of the reply.
     * @type {Array<WebApiModelsReplyTimes>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    replyTime?: Array<WebApiModelsReplyTimes> | null;
    /**
     * The household the member can sign up: the member first, then the family members.
     * Empty when the member can only answer for themselves.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto
     */
    household?: Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceMemberReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'replyTime': !exists(json, 'replyTime') ? undefined : (json['replyTime'] === null ? null : (json['replyTime'] as Array<any>).map(WebApiModelsReplyTimesFromJSON)),
        'household': !exists(json, 'household') ? undefined : (json['household'] === null ? null : (json['household'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceMemberReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceMemberReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'replyId': value.replyId,
        'message': value.message,
        'replyTime': value.replyTime === undefined ? undefined : (value.replyTime === null ? null : (value.replyTime as Array<any>).map(WebApiModelsReplyTimesToJSON)),
        'household': value.household === undefined ? undefined : (value.household === null ? null : (value.household as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdMemberDtoToJSON)),
    };
}

